import type { ManagedDbService, ManagedServiceEnum } from "@warrenio/api-spec/spec.oats.gen";

const validValues: ManagedServiceEnum[] = ["mariadb", "postgresql"];

export function isDbService(value: ManagedServiceEnum): value is ManagedDbService["service"] {
    return validValues.includes(value);
}
